import { stylePropertyPrefixes } from '../utilities/swan-style.utils.js';

const ROOT_CLASSNAMES = {
    base: 'swan',
    darkMode: `swan-${stylePropertyPrefixes.darkMode}`,
    lightMode: `swan-${stylePropertyPrefixes.lightMode}`,
    themeHoliday: `swan-theme-holiday`
};

export { ROOT_CLASSNAMES };
